import styled from 'styled-components';
import { variables } from '../../../../styles/variables';

export const ActionsElements = styled.span`
  display: flex;
  button {
  border: none;
  padding: 0;
  background-color: ${variables.colorWhite};
  margin: 0 10px 0 0;
  display: inline;
  &:hover,
  &:focus {
    background-color: ${variables.colorWhite};
    &::after {
      content: none;
    }
  }
  &.ant-btn[disabled] {
    background-color: ${variables.colorWhite};
  }
  .smaller {
    transform: scale(0.85);
  }
}
`;